import { useEffect, useState } from "react";
import Window from "../window/Window";

function CodeSources() {
  const [branches, setbranches] = useState([]);
  const [files, setFiles] = useState([]);
  const [link, setLink] = useState(
    "https://api.github.com/repos/pierre-lhoste/Pierre-LHOSTE.github.io/git/trees/"
  );
  const [active, setActive] = useState("main");

  useEffect(() => {
    fetch(
      "https://api.github.com/repos/pierre-lhoste/Pierre-LHOSTE.github.io/branches"
    )
      .then((res) => res.json())
      .then((obj) => {
        setbranches(obj.map((br) => br.name));
      });
  }, []);

  useEffect(() => {
    updateFiles();
  }, [branches.length, active]);

  function openFile(file) {
    if (file.type == "tree") {
      
      updateFiles(file.url);
    } else if (file.type == "blob") {
      console.log(link);
    };
  }

  function updateFiles(url) {
    if (!url) url = link + active;
    fetch(url)
      .then((res) => res.json())
      .then((obj) => {
        if (obj.tree) {
          let data = obj.tree.sort(function (a, b) {
            return b.type.localeCompare(a.type);
          });
          setFiles(data);
        } else {
          setFiles([{path: "Error ! " + obj.message.split(" (")[0],type: "error"}])
        }
      });
  }

  return (
    <Window id="sources" title="Explorateur">
      <nav>
        <ul>
          {["main", "assets"].map((br) => (
            <li
              className={br == active ? "active" : ""}
              onClick={() => setActive(br)}
            >
              {br}
            </li>
          ))}
        </ul>
      </nav>
      <ul>
        <li onClick={() => openFile({ url: link + active, type: "tree" })}>
          ...
        </li>
        {files
          .sort((a, b) => {
            return a.type - b.type;
          })
          .map((file, i) => (
            <li className={file.type} onClick={() => openFile(file)}>
              {file.path}
            </li>
          ))}
      </ul>
    </Window>
  );
}

export default CodeSources;
